import { FC } from 'react';

import { Groups as UIGroups } from './groups.styles';

export type childs = {
  children: React.ReactNode;
};

export const Groups: React.FC<childs> = ({ children }) => (
  <UIGroups>{children}</UIGroups>
);
